import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-page-footer',
  imports: [RouterLink],
  templateUrl: './page-footer.component.html',
  styleUrl: './page-footer.component.scss',
})
export class PageFooterComponent {}
